import { SimpleBars } from '../../Common/Charts/SimpleBars';
import { useProceduresChartsDataContext } from './hooks/useProceduresChartsDataContext';

export const ProceduresTop = () => {
    const { chartData } = useProceduresChartsDataContext();

    const topProcedimentos = chartData?.top || [];
    const subtitles = topProcedimentos.map((item) => item.descricao);
    const values = topProcedimentos.map((item) => item.total);

    return (
        <SimpleBars
            title={'Top 20 Procedimentos Realizados'}
            values={values}
            subtitles={subtitles}
            horizontal
            height={550}
        />
    );
};
